import { MessageCircle, Phone } from "lucide-react";
import { BUSINESS } from "@/App";

export default function FloatingButtons() {
  return (
    <>
      {/* Desktop/mobile floating WhatsApp */}
      <a
        href={`https://wa.me/${BUSINESS.whatsapp}?text=${encodeURIComponent(
          "Hi, I'd like a painting quote."
        )}`}
        target="_blank"
        rel="noreferrer"
        data-testid="whatsapp-fab"
        aria-label="Chat on WhatsApp"
        className="fixed z-40 bottom-20 md:bottom-6 right-4 md:right-6 h-14 w-14 rounded-full bg-[#25D366] hover:bg-[#1EB559] grid place-items-center shadow-[0_12px_30px_rgba(37,211,102,0.45)] transition-transform hover:scale-105"
      >
        <MessageCircle className="h-7 w-7 text-white" />
        <span className="absolute -top-1 -right-1 h-3.5 w-3.5 bg-orange-500 rounded-full border-2 border-white animate-ping" />
      </a>

      {/* Mobile bottom sticky bar */}
      <div className="fixed bottom-0 inset-x-0 z-40 md:hidden glass border-t border-slate-200">
        <div className="flex">
          <a
            href={`tel:${BUSINESS.phoneRaw}`}
            data-testid="mobile-sticky-call"
            className="flex-1 h-14 flex items-center justify-center gap-2 font-bold text-ink"
          >
            <Phone className="h-4 w-4" /> Call Now
          </a>
          <div className="w-px bg-slate-200" />
          <a
            href={`https://wa.me/${BUSINESS.whatsapp}`}
            target="_blank"
            rel="noreferrer"
            data-testid="mobile-sticky-whatsapp"
            className="flex-1 h-14 flex items-center justify-center gap-2 font-bold text-white bg-orange-500"
          >
            <MessageCircle className="h-4 w-4" /> WhatsApp
          </a>
        </div>
      </div>
    </>
  );
}
